export default function PressKit() {
  const resources = [
    {
      title: 'Company Logo Pack',
      description: 'High-resolution logos in various formats (PNG, SVG, EPS)',
      icon: 'ri-image-line',
      size: '2.5 MB'
    },
    {
      title: 'Brand Guidelines',
      description: 'Complete brand identity and usage guidelines',
      icon: 'ri-palette-line',
      size: '4.8 MB'
    },
    {
      title: 'Executive Photos',
      description: 'High-resolution photos of leadership team',
      icon: 'ri-user-line',
      size: '12.3 MB'
    },
    {
      title: 'Product Screenshots',
      description: 'Platform interface and feature screenshots',
      icon: 'ri-screenshot-line',
      size: '8.7 MB'
    },
    {
      title: 'Company Fact Sheet',
      description: 'Key statistics, milestones, and company information',
      icon: 'ri-file-text-line',
      size: '1.2 MB'
    },
    {
      title: 'Video Assets',
      description: 'Company overview and promotional videos',
      icon: 'ri-video-line',
      size: '156 MB'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Press Kit & Media Resources
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Download official TrackVerse media assets and resources
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {resources.map((resource, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 border border-gray-200 hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${resource.icon} text-2xl text-green-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {resource.title}
              </h3>
              <p className="text-sm text-gray-600 mb-4">
                {resource.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-gray-500">{resource.size}</span>
                <button className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-download-line"></i>
                  Download
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-download-cloud-line text-xl"></i>
            Download Complete Press Kit
          </button>
        </div>
      </div>
    </section>
  );
}
